import React, { useEffect } from 'react';

import { observer } from 'mobx-react-lite';

import {
  TableFooter,
  roundInfoStore,
  userCountStore,
  userInfoStore,
  betStore,
} from '@pascal/pascal-core';

import { totalBetStore } from '../../store/totalBetStore';

import { numberRound } from '../../helpers/numberRound';

const FooterWr = observer(() => {
  const { roundId } = roundInfoStore;
  const { totalBet } = totalBetStore;
  const { usersCount } = userCountStore;
  const { repliedBetData } = betStore;

  useEffect(() => {
    return () => userInfoStore.setDemoInitialBalance();
  }, []);

  return (
    <>
      {!repliedBetData && (
        <TableFooter
          roundId={`${roundId}`}
          usersCount={usersCount}
          totalBet={numberRound(totalBet)}
          // demoSwitcherAdditionalFunction={() => doBetStore.mapRealBetsToPigsData()}
        />
      )}
    </>
  );
});

export default FooterWr;
